export default __webpack_public_path__ + "static/media/token.444db43b.jpg";